// Auto-generated by scripts/set-env.js — do not edit manually.
export const environment = {
  PRODUCTION: false,
  CLIENT_ID: '598ffe73-a670-4e09-b6cb-aef44abf0e7f',
  TENANT_ID: '3d6abd93-02ca-4049-8ea0-353c825300a7',
  SSO_AUTHORITY: 'https://login.microsoftonline.com/',
  REDIRECT_URI: 'https://itemguard-dev.nabp.pharmacy/callback',
  SCOPE: 'api://598ffe73-a670-4e09-b6cb-aef44abf0e7f/access_as_user',
  API_BASE_URL: 'https://api.itemguard-dev.nabp.pharmacy/api/v1',
  X_API_KEY: 's9wIXOIT4s7p4CD5nuiPf7loNXO5vuka12qYCeT5',
  IDLE_SECONDS: 3600,
  TIMEOUT_SECONDS: 60,
};
